import { PATHS } from '../configs';
import client from '../services/client';

import type { ChainStoreInvoice, SupportReceiptType } from '../types';

type GetLinePayInitUrlProps = {
  invoice: ChainStoreInvoice;
  email: string | undefined;
  receipt: {
    name: string;
    phone: string;
    barcode?: string;
    type: SupportReceiptType;
    ubn?: string;
    donate?: string;
  };
  callbackParams: {
    serviceUid: string;
    captureMethod: string;
    amount: string;
    merchantUid: string;
  };
};

export const getLinePayInitUrl = async ({
  invoice,
  email,
  receipt,
}: GetLinePayInitUrlProps) => {
  const callbackUrl = `${window.location.origin}${PATHS.INVOICES(invoice.id)['']}`;

  const {
    data: {
      data: { web_link },
    },
  } = await client.initLinePayTransaction({
    invoiceId: invoice.id,
    email,
    receipt,
    callbackUrl,
  });

  return web_link;
};
